<template>
  <div class="blog">
    <div class="container" v-scroll-reveal="{ origin : 'top', duration : '1000', distance : '100px' }">
      <div class="blog-listing">
        <!-- Content Area -->

        <article class="type-post">
          <div class="layout-5">
            <div class="entry-cover">
              <a title="Cover" v-on:click="goBlogDetail(1)"><img src="static/images/blog/1/1.png"></a>
            </div>
          </div>
          <div class="layout-5">
            <div class="entry-contentbox">
              <h3>식당 고객  만족도 조사 서비스 런치스타 출시</h3>
              <p class="post-date">06.30, 2018</p>

              <div class="entry-content">
                <p class="entry-content">런치스타는
                  구내식당 이용자를 대상으로 하는 상시 설문 조사 시스템입니다.
                  기존의 설문조사 방식이나, 스티커 방식의 번거로운 방식을 탈피하여, 매
                  식수별 이용자들의 만족정도를 수집 할 수 있습니다.
                  런치스타는 수집된 정보를 바탕으로 다양한 통계를 제공합니다. 제공되는
                  통계 정보를 바탕으로 식당 운영자들은 이용자들의 만족정도를 쉽게
                  분석하여, 구내식당 운영에 필요한 개선항목을들 명확하게 파악할 수
                  있습니다.
                </p>
              </div>
              <div class="read-more">
                <a v-on:click="goBlogDetail(1)" title="Read More">Read More<i class="fa fa-angle-right"></i></a>
              </div>
            </div>
          </div>
        </article>
        <article class="type-post">
          <div class="layout-5">
            <div class="entry-cover">

              <a title="Cover" v-on:click="goBlogDetail(2)"><img src="static/images/blog/2/2.png"></a>
            </div>
          </div>
          <div class="layout-5">
            <div class="entry-contentbox">
              <h3>i-award smart app award 건강/의료분야  대상 수상</h3>
              <p class="post-date">12.07, 2017</p>
              <div class="entry-content">
                <p>레나소프트웨에서 개발한 함소아 어플리케이션이 2017년도 App Award Korea에서 건강/의료분야 대상을 수상하였습니다.
                  각계 각층의 전문가들과 종사자들이 평가하고 시상하는 권위있는 “앱어워드 2017” 행사가 2017년 12월 7일 잠실 롯데 호텔에서 진행 되었습니다.
                  앱 어워드 2017행사는 2017년도 한해 동안 제작하였던 앱을 회원들과 전문 평가위원들이 함께 평가하고, 시상하고, 기술 발전을 위해 함께 논의하는 자리입니다.
                </p>
              </div>
              <div class="read-more">
                <a v-on:click="goBlogDetail(2)" title="Read More">Read More<i class="fa fa-angle-right"></i></a>
              </div>
            </div>
          </div>
        </article>
        <article class="type-post">
          <div class="layout-5">
            <div class="entry-cover">
              <a title="Cover" v-on:click="goBlogDetail(3)"><img src="static/images/blog/3/3.png"></a>
            </div>
          </div>
          <div class="layout-5">
            <div class="entry-contentbox">
              <h3>동영상 제작 어플리케이션 스냅무비 다운로드
                500만명 돌파
              </h3>
              <p class="post-date">12.13, 2016</p>

              <div class="entry-content">
                <p>레나소프트웨어에서 개발한 동영상 촬영 어플리케이션이 매출순위와 앱 다운로드 순위에서 모두 1위를 차지하는 등 인기 상한가를 달리고 있다.
                  영예의 어플리케이션은 코리아텍 졸업생들인 권병천(컴퓨터공학부. 99학번), 심진웅( 〃 04학번), 김지훈( 〃 06학번), 박아름(디자인공학과, 07학번)씨로 구성된 ㈜레나소프트웨어(2010년 설립)가 지난 2월 만든 '스냅무비(로드무비 메이커)'다.
                </p>
              </div>
              <div class="read-more">
                <a v-on:click="goBlogDetail(3)" title="Read More">Read More<i class="fa fa-angle-right"></i></a>
              </div>
            </div>
          </div>
        </article>

        <!--&lt;!&ndash; Ow Pagination &ndash;&gt;-->
        <!--<nav class="ow-pagination">-->
        <!--<ul>-->
        <!--<li class="active"><a href="#" title="">1</a></li>-->
        <!--<li><a href="#" title="">2</a></li>-->
        <!--<li><a href="#" title="">...</a></li>-->
        <!--<li><a href="#" title="">4</a></li>-->
        <!--<li class="next"><a href="#" title=""><i class="fa fa-angle-right"></i></a></li>-->
        <!--</ul>-->
        <!--</nav>&lt;!&ndash; Ow Pagination /- &ndash;&gt;-->
      </div>

    </div>
  </div><!-- Blog /- -->
</template>

<script>
  export default {
    name: 'Blog',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      goBlogDetail( no ) {
        this.$router.push("Blog"+ no )
        //console.log('## click menu : ' + title)
        //this.menuVisible = false
        //this.$emit('clicked',title)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue